import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebviewService } from '@app/services/webview.service';

export enum ConfirmType {
  ORIGINAL, STACK_BTN
}

export interface DialogData {
  excuteText: string;
  cancelText: string;
  content: string;
  style?: any;
}


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private webViewService: WebviewService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }
  ngAfterViewInit(): void {
    this.contentTemplate.nativeElement.innerHTML = this.data.content;
  }
  @ViewChild('template') contentTemplate!: ElementRef<HTMLElement>;
  cofirmType = ConfirmType;
  ngOnInit(): void {
    this.webViewService.kidsConfirmDialogIntercepter();
  }

  ngOnDestroy(): void {
    this.webViewService.kidsConfirmDialogIntercepter(false);
  }
}
